<template>
  <div>
    <div class="course_apply">
      <h2>
        I would like to apply for: {{ course.course_title.name }}, {{ course.whenMonthFull }}
      </h2>



<!-- Button trigger modal -->
<button type="button" 
  ref="modelBtn"
  class="px-6
      hidden
      py-2.5
      bg-blue-600
      text-white
      font-medium
      text-xs
      leading-tight
      uppercase
      rounded
      shadow-md
      hover:bg-blue-700 hover:shadow-lg
      focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0
      active:bg-blue-800 active:shadow-lg
      transition
      duration-150
      ease-in-out" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Launch demo modal
</button>

<!-- Modal -->
<div class="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-xl relative w-auto pointer-events-none">
    <div class="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">

      <div class="modal-body relative p-4">
          <div v-if="form.errors.any()">            
            <div class="whitespace-pre mb-4 text-sib_red">{{ message }}</div>
          </div>
          <div v-else>
            <div class="whitespace-pre mb-4">{{ message }}</div>
            <p>Note: A copy of the above information has been sent to the email address you provided.</p>
            <p>More SIB events at <a href="https://www.sib.swiss/about-us/events" target="_blank">SIB Training</a></p>
          </div>
      </div>

    </div>
  </div>
</div>




      <form @submit.prevent="save()">
        <div class="form-group">
          <label>
            Apply as
            <span class="required"
              >*

              <span v-if="form.errors.get('apply_as')">{{
                form.errors.get("apply_as")
              }}</span></span
            >
          </label>
          <div class="sm:flex">
            <select v-model="form.apply_as" required>
              <option value="">Please select</option>
              <option value="Academia/ Research institution">
                Academia/ Research institution
              </option>
              <option value="Industry">Industry</option>
              <option value="Non-Profit Organisation">
                Non-Profit Organisation
              </option>
              <option value="Healthcare">Healthcare</option>
              <option value="Other">Other &gt;&gt;</option>
            </select>

            <div
              v-if="form.apply_as === 'Other'"
              class="mt-2 sm:mt-0 sm:ml-2 sm:w-80"
            >
              <input
                type="text"
                v-model="form.apply_as_other"
                placeholder="Please, specify"
                class="w-full"
                required
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <label
            >Course fee: {{ coursefee ? "CHF " + coursefee : "no fee" }}</label
          >
        </div>

        <div class="form-group">
          <label
            >First name<span class="required"
              >*

              <span v-if="form.errors.get('firstname')">{{
                form.errors.get("firstname")
              }}</span>
            </span></label
          ><br />
          <input
            class="w-full"
            type="text"
            placeholder="First name"
            v-model="form.firstname"
            required
          />
        </div>

        <div class="form-group">
          <label
            >Last name<span class="required"
              >*

              <span v-if="form.errors.get('lastname')">{{
                form.errors.get("lastname")
              }}</span></span
            ></label
          ><br />
          <input
            class="w-full"
            type="text"
            placeholder="Last name"
            v-model="form.lastname"
            required
          />
        </div>

        <div class="form-group">
          <label
            >Gender<span class="required"
              >*

              <span v-if="form.errors.get('gender')">{{
                form.errors.get("gender")
              }}</span></span
            ></label
          >
          <div class="sm:flex">
            <select v-model="form.gender" required>
              <option value="">Please select</option>
              <option value="Female">Female</option>
              <option value="Male">Male</option>
              <option value="Prefer not to say">Prefer not to say</option>
              <option value="Other">Other &gt;&gt;</option>
            </select>

            <div
              v-if="form.gender === 'Other'"
              class="mt-2 sm:mt-0 sm:ml-2 sm:w-80"
            >
              <input
                type="text"
                v-model="form.gender_other"
                placeholder="Please, specify"
                class="w-full"
                required
                
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <label
            >Career stage<span class="required"
              >*

              <span v-if="form.errors.get('status')">{{
                form.errors.get("status")
              }}</span></span
            ></label
          >
          <div class="sm:flex">
            <select v-model="form.status" required>
              <option value="">Please select</option>
              <option value="Masters student">Masters student</option>
              <option value="PhD candidate">PhD candidate</option>
              <option value="Postdoctoral researcher">
                Postdoctoral researcher
              </option>
              <option value="Senior scientist/ Principal investigator">
                Senior scientist/ Principal investigator
              </option>
              <option value="Research assistant/ Technician">
                Research assistant/ Technician
              </option>
              <option value="Other">Other &gt;&gt;</option>
            </select>

            <div
              v-if="form.status === 'Other'"
              class="mt-2 sm:mt-0 sm:ml-2 sm:w-80"
            >
              <input
                type="text"
                v-model="form.career_stage_other"
                placeholder="Please, specify"
                class="w-full"
                
              />
            </div>
          </div>
        </div>

        <div v-if="form.status === 'PhD candidate'" class="form-group">
          <label class="control-label">Doctoral Program</label>
          <div class="sm:flex">
            <select v-model="form.lddocprog" size="1">
              <option value="">Please select</option>
              <option value="StarOmics">StarOmics</option>
              <option value="Population Genomics">Population Genomics</option>
              <option value="IECB">IECB</option>
              <option value="SIB PhD">SIB PhD Training Network</option>
              <option value="other">Other &gt;&gt;</option>
            </select>
            <div
              v-if="form.lddocprog === 'other'"
              class="mt-2 sm:mt-0 sm:ml-2 sm:w-80"
            >
              <input
                type="text"
                v-model="form.docprog"
                placeholder="Please, specify"
                class="w-full"
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <label
            >Institution<span class="required"
              >*

              <span v-if="form.errors.get('ldinstitution')">{{
                form.errors.get("ldinstitution")
              }}</span></span
            ></label
          >
          <div class="sm:flex">
            <select v-model="form.ldinstitution" required>
              <option value="">Please select</option>
              <option v-for="institution in institutions" :key="institution">
                {{ institution }}
              </option>
              <option value="Other">Other &gt;&gt;</option>
            </select>

            <div
              v-if="form.ldinstitution === 'Other'"
              class="mt-2 sm:mt-0 sm:ml-2 sm:w-80"
            >
              <input
                type="text"
                v-model="form.institution"
                placeholder="Please, specify"
                class="w-full"
                required
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <label
            >Department<span class="required"
              >*

              <span v-if="form.errors.get('departement')">{{
                form.errors.get("departement")
              }}</span></span
            ></label
          ><br />
          <input
            type="text"
            placeholder=""
            v-model="form.departement"
            required
          />
        </div>

        <div class="form-group">
          <label>Thesis supervisor or Lab Head (if applicable)</label><br />
          <input
            type="text"
            placeholder=""
            v-model="form.supervisor"
            size="38"
          />
        </div>

        <div class="form-group">
          <label
            >Country of employment<span class="required"
              >*

              <span v-if="form.errors.get('country_of_employment')">{{
                form.errors.get("country_of_employment")
              }}</span></span
            ></label
          >

          <select v-model="form.country_of_employment" required>
            <option value="">Please select</option>
            <option v-for="country in countries" :key="country">
              {{ country }}
            </option>
          </select>
        </div>

        <div
          v-if="form.country_of_employment === 'Switzerland'"
          class="form-group"
        >
          <label
            >Canton of employment<span class="required"
              >*

              <span v-if="form.errors.get('canton')">{{
                form.errors.get("canton")
              }}</span></span
            ></label
          >

          <select class="w-80" v-model="form.canton" required>
            <option value="">Please select</option>
            <option v-for="canton in cantons" :key="canton">
              {{ canton }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label
            >City<span class="required"
              >*

              <span v-if="form.errors.get('city')">{{
                form.errors.get("city")
              }}</span></span
            ></label
          ><br />
          <input type="text" placeholder="" v-model="form.city" required />
        </div>

        <div class="form-group">
          <label>Phone number<span class="required">* </span>            
            <small>(will only be used in case of emergency or tracing due to COVID-19)</small>
            <span v-if="form.errors.get('phone')">{{
                form.errors.get("phone")
              }}</span>
          </label><br />
          <input type="text" placeholder="" v-model="form.phone" required />
          <span>Example: +41 21 692 50 50</span>
        </div>

        <div class="form-group">
          <label
            >Professional Email<span class="required"
              >*

              <span v-if="form.errors.get('email')">{{
                form.errors.get("email")
              }}</span></span
            ></label
          ><br />
          <input type="email" placeholder="" v-model="form.email" required />          
        </div>

        <div class="form-group">
          <label
            >Where did you see the course advertised?<span class="required"
              >*
                <span v-if="form.errors.get('course_advertisement')">{{
                form.errors.get("course_advertisement")
        }}</span></span></label>
          <div class="sm:flex">
            <select v-model="form.course_advertisement" required>
              <option value="">Please select</option>
              <option v-for="ad in ads" :key="ad">
                {{ ad }}
              </option>
              <option value="Other">Other &gt;&gt;</option>
            </select>

            <div
              v-if="form.course_advertisement === 'Other'"
              class="mt-2 sm:mt-0 sm:ml-2 sm:w-80"
            >
              <input
                type="text"
                v-model="form.course_advertisement_other"
                placeholder="Please, specify"
                class="w-full"
                required
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>We are trying our best to make SIB courses accessible to participants with disabilities. Should you have any special requirements, please let us know below.</label><br />
          <textarea placeholder="" rows="10" v-model="form.special_requirements"></textarea>
        </div>
        
        <div class="form-group">
          <label>Comment</label><br />
          <textarea placeholder="" rows="10" v-model="form.comments"></textarea>
        </div>

        <div class="text-center">
          <input v-model="form.acceptconditions" type="checkbox" />
          &nbsp;I accept general
          <a
            href="https://www.sib.swiss/training/terms-and-conditions"
            target="_blank"
            class="text-sibred no-underline"
            >course conditions</a
          >

          &nbsp;
          <button
            type="submit"
            class="
              inline-block
              px-6
              py-1
              text-gray-700
              bg-gray-200
              border-gray-300 border
              disabled:opacity-60
            "
            :disabled="form.acceptconditions != true"
          >
            APPLY NOW
            {{
              course.registration_status === "waiting-list"
                ? "FOR WAITING LIST "
                : ""
            }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Form } from "vform";
export default {
  props: ["appUrl", "course", "institutions", "countries", "cantons", "ads"],

  data: () => ({
    ldinstitution: "",
    lddocprog: "",
    country_of_employment: "Switzerland",
    course_advertisement: "",
    acceptconditions: false,
    form: new Form(),
    message: "",
  }),

  mounted() {
    console.log("course apply component mounted");
    this.initializeForm();
  },

  computed: {
    coursefee() {
      if (this.form && this.form.apply_as === "Industry") {
        return this.course.default_course_fee_forprofit;
      }
      return this.course.default_course_fee;
    },
  },
  methods: {
    initializeForm() {
      this.form = new Form({
        apply_as: "",
        apply_as_other: "",
        firstname: "",
        lastname: "",
        gender: "",
        status: "",
        career_stage_other: "",
        lddocprog: "",
        ldinstitution: "",
        institution: "",
        departement: "",
        supervisor: "",
        country_of_employment: "",
        canton: "",
        city: "",
        phone: "",
        email: "",
        course_advertisement: "",
        course_advertisement_other: "",
        special_requirements: "",
        comments: "",
        acceptconditions: "",
      });

      // // uncomment for easy test form
      // this.form = new Form({
      //   apply_as: "Industry",
      //   apply_as_other: "",
      //   firstname: "Silvano",
      //   lastname: "Aldà",
      //   gender: "Male",
      //   status: "Masters student",
      //   career_stage_other: "",
      //   lddocprog: "",
      //   ldinstitution: "Université de Lausanne",
      //   institution: "",
      //   departement: "Mydepartement",
      //   supervisor: "mysupervisor",
      //   country_of_employment: "Switzerland",
      //   canton: "Vaud (VD)",
      //   city: "Lausanne",
      //   phone: "+41 21 692 50 50",
      //   email: "silvano22.alda@sib.swiss",
      //   course_advertisement: "SIB newsletter",
      //   course_advertisement_other: "",
      //   comments: "my comments",
      //   acceptconditions: true,
      // });
    },
    save() {
      this.form
        .submit(
          "post",
          this.appUrl + "/api/courses/" + this.course.id + "/apply"
        )
        .then((data) => {
          console.log("then", data);
          this.message = data.data.message;
          this.$refs.modelBtn.click();
          this.initializeForm(); //data.data);
        })
        .catch((e) => {
          //console.log("catch", e.response, this.form);

          this.message = e.response.data.message;
          this.$refs.modelBtn.click();
        });
    },
  },
};
</script>
